// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3E1Xu","branches":"_1RdzC"};